const accordions = document.querySelectorAll('[data-spark-accordion]')

accordions?.forEach((accordion: any) => {
  accordion.addEventListener('click', (element: any) => {
    if (accordion.dataset.sparkHydrated === 'true') {
      return
    }

    const { target } = element
    const { dataset } = target

    if (dataset.sparkAccordionButton) {
      const open = dataset.sparkAccordionOpen === 'true'
      const content = target.nextSibling

      const icon = target.querySelector('[data-ev-accordion]')

      target.setAttribute('data-spark-accordion-open', !open)

      if (open) {
        content.style.height = '0px'
        content.style.overflow = 'hidden'
        content.childNodes[0].style.display = 'none'
        content.childNodes[0].childNodes[0].style.opacity = 0
        content.childNodes[0].childNodes[0].style.visibility = 'hidden'

        if (icon) icon.style.transform = 'rotate(0.5turn)'
      } else {
        content.style.height = 'auto'
        content.style.overflow = 'visible'
        content.childNodes[0].style.display = 'block'
        content.childNodes[0].childNodes[0].style.opacity = 1
        content.childNodes[0].childNodes[0].style.visibility = 'visible'

        if (icon) icon.style.transform = 'none'
      }
    }
  })
})
